module.exports = __webpack_public_path__ + "assets/306d95493413b69cbbcdefcdffeb43bf.mp3";